
export default {
  methods: {
    goToNewDashboard() {
      localStorage.removeItem("dashboard_version");
      window.location.reload();
    },
  },
};
